<template>
    <div :class="contentClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            isCenter: { type: Boolean, default: false },
            isFull: { type: Boolean, default: false },
        },

        computed: {
            contentClass() {
                return {
                    widget__content: true,
                    'widget__content--is-center': this.isCenter,
                    'widget__content--is-full': this.isFull,
                }
            },
        },
    }
</script>
